<template>
    <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M23.25 5.49847H20.25L19.9144 4.82769C19.6603 4.31953 19.141 3.99852 18.5728 3.99848H15.3094L14.0306 2.71974C13.8778 2.56693 13.6898 2.49849 13.5056 2.49849C13.1198 2.49849 12.75 2.79802 12.75 3.24989V10.7972L1.09594 1.08522C0.937031 0.952569 0.700312 0.974131 0.567656 1.1335L0.0871875 1.71006C-0.0454687 1.86897 -0.0239062 2.10568 0.135 2.23834L11.2472 11.4984H7.5C6.58172 11.4984 5.73 11.7764 5.01797 12.2484H3.75C2.50922 12.2484 1.5 11.2392 1.5 9.99843C1.5 9.58405 1.16438 9.24843 0.75 9.24843C0.335625 9.24843 0 9.58405 0 9.99843C0 12.0253 1.61859 13.6715 3.63094 13.7362C3.24 14.4032 3 15.1696 3 15.9984V23.4983C3 24.3266 3.67172 24.9983 4.5 24.9983H7.5C8.32828 24.9983 9 24.3266 9 23.4983V18.9983H13.5V23.4983C13.5 24.3266 14.1717 24.9983 15 24.9983H18C18.8283 24.9983 19.5 24.3266 19.5 23.4983V12.2484H21C22.657 12.2484 24 10.9054 24 9.24843V6.24846C24 5.83409 23.6644 5.49847 23.25 5.49847ZM12 17.4984H7.5V23.4983H4.5V15.9984C4.5 14.3442 5.84578 12.9984 7.5 12.9984H12V17.4984ZM15 17.4984V23.4983H18V14.2396L13.5 13.1146V17.4984H15ZM22.5 9.24843C22.5 10.0753 21.8269 10.7484 21 10.7484H18V12.6947L14.25 11.7572V5.06066L14.6878 5.49847H18.5728L19.3228 6.99845H22.5V9.24843ZM16.5 7.74845C16.5 7.33407 16.8356 6.99845 17.25 6.99845C17.6644 6.99845 18 7.33407 18 7.74845C18 8.16282 17.6644 8.49844 17.25 8.49844C16.8356 8.49844 16.5 8.16282 16.5 7.74845Z"
            fill="currentColor"
        />
    </svg>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "DogLeashedIcon",
});
</script>
